/**
 * @generated SignedSource<<1b01550b573cb743945e7e1bc9c13c02>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ui_nativeIssueTable_NativeIssueTable_project$data = {
  readonly " $fragmentSpreads": FragmentRefs<"issueTable_nativeIssueTable_project" | "realtimeUpdater_nativeIssueTable_project">;
  readonly " $fragmentType": "ui_nativeIssueTable_NativeIssueTable_project";
};
export type ui_nativeIssueTable_NativeIssueTable_project$key = {
  readonly " $data"?: ui_nativeIssueTable_NativeIssueTable_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"ui_nativeIssueTable_NativeIssueTable_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "ui_nativeIssueTable_NativeIssueTable_project",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "realtimeUpdater_nativeIssueTable_project"
    },
    {
      "kind": "FragmentSpread",
      "name": "issueTable_nativeIssueTable_project"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "0678b5e51ae704bd61d400676eed0313";

export default node;
